<template>
  <div class="log-detail">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar">
      <el-col :span="6">更新时间：{{info.startTime}}</el-col>
      <el-col :span="6">途径：{{info.channel}}</el-col>
       <el-col :span="6">店铺：{{info.source}}</el-col>
    </el-row>
     <el-tabs v-model="activeName">
        <el-tab-pane label="全部" name="all">
          <span slot="label">全部（{{info.total || 0}}）</span>
          <Table :list="allList" />
        </el-tab-pane>
        <el-tab-pane label="成功" name="sucess">
          <span slot="label">成功（{{info.successTotal || 0}}）</span>
          <Table :list="sucessList" />
        </el-tab-pane>
        <el-tab-pane label="失败" name="fail">
          <span slot="label">失败（{{info.failureTotal || 0}}）</span>
          <Table :list="failList" />
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Table from './table.vue'
import { getOperatorLogDetail} from '@servers/prod/log/index'
import { mapGetters, mapActions} from 'vuex'

export default {
  components: {
    Table
  },
  props: ['id'],
  data() {
    return {
      activeName: 'all',
      list: [],
      info: {}
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    allList() {
      return this.list
    },
    sucessList() {
      return this.list.filter(item => item.status == 1)
    },
    failList() {
      return this.list.filter(item => item.status == 0)
    }
  },

  methods: {
    goBack() {
      this.$router.back();
      // this.$router.replace({
      //   name: `${this.routerPrefix}prod_log`
      // })
    },
    async fetch_operatorLogDetail() {
      const res = await getOperatorLogDetail({id: this.id});
      if(!res) return;
      this.list = res.list || [];
      this.info = res.info || {};
    }
  },
  mounted() {
    if(this.id) {
      this.fetch_operatorLogDetail()
    }
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}

</style>
